import store from "../../Redux/store";
import MessageModel from "../Domain/Message.model";
import { setMessages, setSelectedChat } from "../Infrastructure/Chat.reducer";
import { getMessagesByChatService } from "../Infrastructure/Chat.service";

export async function listConversation(
  chatID = store.getState().chat.selected.id
) {
  const data = await getMessagesByChatService(chatID);
  const messages = data?.messageByCreationDate?.items?.map(
    (message) => new MessageModel(message)
  );
  store.dispatch(setMessages(messages));
}

export async function cleanConversation() {
  store.dispatch(setMessages(null));
  store.dispatch(setSelectedChat(null));
}
